<template>
  <div>
    <component :is="currentStep" @done="onSubStepDone"/>
  </div>
</template>

<script>
const flowSteps = [
  'CustomerForm',
  'AdvisorName',
  'StateIdentification',
  'CustomerType',
  'Confirmation'
]

export default {
  name: 'ExistingCustomerFlow',
  data() {
    return {
      currentStepIndex: 0,
      flowData: {}
    }
  },
  computed: {
    currentStep() {
      return flowSteps[this.currentStepIndex];
    }
  },
  methods: {
    onSubStepDone(data) {
      this.flowData = {
        ...this.flowData,
        ...data
      }

      if(data.key !== 'confirmation') {
        this.goToNext();
      } else {
        this.$emit('done', {
          key: 'existingCustomer',
          stepData: this.flowData,
          isFinal: true
        })
      }
    },
    goToNext() {
      this.currentStepIndex = this.currentStepIndex + 1;
    }
  }
}
</script>
